module.exports = __webpack_public_path__ + "img/XL_ETABLISSEMENT.df834052.svg";